import { useEffect, useRef } from "react";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";
import { setFunnelModalConfig } from "../components/funnel/FunnelModal";
import { useIsInReader } from "./useIsInReader";

/**
 * Closes all modals and menus when navigating to/from the reader.
 * This ensures modal state doesn't persist across route changes.
 */
export function useCloseModalsOnReaderChange() {
  const inReader = useIsInReader();
  const prevInReader = useRef(inReader);

  useEffect(() => {
    // Only close modals when reader state actually changes (not on initial mount)
    if (prevInReader.current === inReader) return;
    prevInReader.current = inReader;

    // Close funnel modal
    setFunnelModalConfig();

    // Close slide-in menu
    rootComponentsStore.openSlideInMenu.set(undefined);
    rootComponentsStore.slideInMenuConfig.set({});
    rootComponentsStore.modalDepth.set(0);
  }, [inReader]);
}
